module.exports = __webpack_public_path__ + "static/media/citizenship-icon2.e10ed181.png";